import { useSelector } from 'react-redux';
import { deriveAllowedSportIds } from 'toolkit/allowedSports';
import { sports } from 'toolkit/constants';

export const useAllowedSports = () => {
  const user = useSelector((state) => state.auth.user);
  const allowedSportIds = deriveAllowedSportIds(user);

  const isSportAllowed = (sportId) => {
    if (allowedSportIds === null) return true;
    return allowedSportIds.has(Number(sportId));
  };

  const isSportNameAllowed = (sportName) => {
    const internalId = sports[sportName];
    if (typeof internalId !== 'number') return false;
    return isSportAllowed(internalId);
  };

  return { allowedSportIds, isSportAllowed, isSportNameAllowed };
};
